import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
    faCheckDouble,
    faCoins,
    faExclamation,
    faShoePrints,
    faTimesCircle,
    faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MapLike } from "typescript";
import { useAtedimento } from "../../../../Context/Atendimento";
import { AtualizarNotificacaoComoLida } from "../../../../Controllers/Geral/Notificacao/NotificacaoControllers";
import { INotificacao } from "../../../../Interfaces/Geral/Notificacao/NotificacaoInterfaces";
import { formatMessageDate } from "../../../../Tools/FormatTools";
import SpinnerComponent from "../../../Loding/Spinner";
import HTMLRemover from "../../../Utils/HTMLRemover";

interface INoficacoesUsuarioProps {
    lstNotificacoes: Array<INotificacao> | undefined;
    updateNotificacoes: () => void;
}

interface ITipoNoficacaoPadrao {
    icon: IconProp;
    color: string;
}
const tipoNoficacaoPadroes: MapLike<ITipoNoficacaoPadrao | undefined> = {
    Erros: {
        icon: faTimesCircle,
        color: "danger",
    },
    "Etapas Vencidas": {
        icon: faShoePrints,
        color: "warning",
    },
    "Avançar Etapa": {
        icon: faShoePrints,
        color: "success",
    },
    "Análise de Crédito": {
        icon: faCoins,
        color: "danger",
    },
    Solicitação: {
        icon: faUser,
        color: "info",
    },
};

export default function NoficacoesTransferencia(
    props: INoficacoesUsuarioProps
) {
    const { FL_MODO_ATENDIMENTO } = useAtedimento();
    return (
        <div>
            <div className="navi navi-hover my-4">
                {props.lstNotificacoes ? (
                    props.lstNotificacoes.length ? (
                        props.lstNotificacoes.map((notificacao) => (
                            <span
                                className="navi-item"
                                key={notificacao.ID_NOTIFICACAO}
                            >
                                <div className="navi-link align-items-stretch">
                                    <div className="navi-icon mr-2 d-flex align-items-center">
                                        <FontAwesomeIcon
                                            icon={
                                                tipoNoficacaoPadroes[
                                                    notificacao
                                                        .DS_TIPO_NOTIFICACAO
                                                ]?.icon || faExclamation
                                            }
                                            className={`text-${
                                                tipoNoficacaoPadroes[
                                                    notificacao
                                                        .DS_TIPO_NOTIFICACAO
                                                ]?.color || "primary"
                                            }`}
                                        />
                                    </div>
                                    <OverlayTrigger
                                        overlay={
                                            <Tooltip id="ds_notificacao">
                                                <HTMLRemover onlyRemove>
                                                    {notificacao.DS_NOTIFICACAO}
                                                </HTMLRemover>
                                            </Tooltip>
                                        }
                                        placement={"auto"}
                                        show={
                                            notificacao.DS_NOTIFICACAO.length <
                                            33
                                                ? false
                                                : undefined
                                        }
                                    >
                                        <div className="navi-text">
                                            <div className="font-weight-bold">
                                                {
                                                    notificacao.DS_TIPO_NOTIFICACAO
                                                }
                                            </div>
                                            <span>
                                                {notificacao.DS_NOTIFICACAO
                                                    .length > 33
                                                    ? `${notificacao.DS_NOTIFICACAO.substring(
                                                          0,
                                                          33
                                                      )}...`
                                                    : notificacao.DS_NOTIFICACAO}
                                            </span>
                                            <div className="text-muted">
                                                {formatMessageDate(
                                                    new Date(
                                                        notificacao.DT_CRIACAO
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                        overlay={
                                            <Tooltip id="tooltip-marcar-lido">
                                                Marcar como lida
                                            </Tooltip>
                                        }
                                    >
                                        <div className="h-100">
                                            <span
                                                className="btn btn-light-primary font-weight-bold text-center label label-light-primary label-inline"
                                                onClick={() => {
                                                    AtualizarNotificacaoComoLida(
                                                        notificacao.ID_NOTIFICACAO
                                                    ).then(() => {
                                                        props.updateNotificacoes();
                                                    });
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faCheckDouble}
                                                />
                                            </span>
                                        </div>
                                    </OverlayTrigger>
                                </div>
                            </span>
                        ))
                    ) : (
                        <div className="text-center text-muted">
                            Você não tem nenhuma notificação
                        </div>
                    )
                ) : (
                    <SpinnerComponent />
                )}
                <div className="w-100 d-flex justify-content-center mt-2">
                    <Link
                        to={`/Geral/Notificacoes/transferencia`}
                        className="btn btn-light-primary font-weight-bold text-center"
                        target={FL_MODO_ATENDIMENTO ? "__blank" : ""}
                    >
                        Ver todas
                    </Link>
                </div>
            </div>
        </div>
    );
}
